import { render } from "./PendingItemsList.vue?vue&type=template&id=6cdd3778"
import script from "./PendingItemsList.vue?vue&type=script&lang=js"
export * from "./PendingItemsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__